<ntx-base-page>
  <div *ngIf="title || actions" class="page-header">
    <nb-card-header class="title-header" *ngIf="title">{{ title }}</nb-card-header>
    <div *ngIf="actions" class="actions">
      <button
        nbButton
        *ngFor="let action of actions"
        class="click-animate"
        (click)="action.onAction()"
        [disabled]="action.disabled"
        [nbTooltip]="action.title"
        status= "primary"
        appearance= "ghost"
        size= "large"
        shape= "round"
      >
        <span *ngIf="action.text">{{ action.text }}</span>
        <i *ngIf="action.icon" class="la la-{{ action.icon }} la-2x"></i>
      </button>
    </div>
  </div>

  <div class="header-cards">
    <nb-card *ngFor="let card of headerCards" class="header-card card-shadow">
      <div class="title h6">
        {{ card.title }}
      </div>
      <div class="value">
        {{card.value}}
      </div>
    </nb-card>
  </div>
  <div class="content">
    <ng-content></ng-content>
  </div>
  <div class="entity-summary" *ngIf="entitySummary">
    <nb-card>
      <smart-table [title]="entitySummary.title" [settings]="entitySummary.settings"
        [source]="entitySummary.source"></smart-table>
    </nb-card>
  </div>
</ntx-base-page>
